import { useState } from 'react';
import '../components/home/home.css';
import PageLayout from '../components/home/PageLayout';

export default function ContactUsPage() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = e => {
    e.preventDefault();
    // In a real app this would POST to an API
    setSent(true);
    setForm({ name: '', email: '', message: '' });
  };

  return (
    <PageLayout title="Contact Us" breadcrumb="Contact">
      <div className="sa-container" style={{ padding: '48px 15px' }}>
        <div className="sa-contact-layout">

          {/* ── Left: contact info ── */}
          <div className="sa-contact-info-col">
            <ul className="sa-contact-info-list">
              <li>
                <span className="sa-ci-icon"><i className="fa fa-phone" /></span>
                <div>
                  <h4>Phone</h4>
                  <p><a href="tel:+919511840674">+91 9511840674</a></p>
                  <p><a href="tel:02025460262">020-25460262</a></p>
                </div>
              </li>
              <li>
                <span className="sa-ci-icon"><i className="fa fa-map-marker" /></span>
                <div>
                  <h4>Address</h4>
                  <p>
                    Somayya Academy, Parthasarathi Building,<br />
                    Near City Pride-Kothrud, Kothrud,<br />
                    Pune – 411038
                  </p>
                </div>
              </li>
              <li>
                <span className="sa-ci-icon"><i className="fa fa-envelope-o" /></span>
                <div>
                  <h4>E-mail</h4>
                  <p><a href="mailto:info@somayyaacademy.com">info@somayyaacademy.com</a></p>
                </div>
              </li>
              <li>
                <span className="sa-ci-icon"><i className="fa fa-clock-o" /></span>
                <div>
                  <h4>Office Hours</h4>
                  <p>Monday – Saturday: 9:00am – 8:00pm</p>
                </div>
              </li>
            </ul>

            {/* Social icons */}
            <div style={{ marginTop: 24 }}>
              <h4 style={{ color: 'var(--sa-primary)', marginBottom: 12 }}>Follow Us</h4>
              <div className="sa-footer-social">
                <a href="https://www.facebook.com/somayya.classes.9/" target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook" /></a>
                <a href="https://www.linkedin.com/in/somayya-classes/" target="_blank" rel="noopener noreferrer"><i className="fa fa-linkedin" /></a>
                <a href="https://www.instagram.com/somayyaclasses147/" target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram" /></a>
              </div>
            </div>
          </div>

          {/* ── Right: contact form ── */}
          <div className="sa-contact-form-col">
            <h2 className="sa-inner-section-title">Send Us a Message</h2>
            {sent ? (
              <div className="sa-form-success">
                <i className="fa fa-check-circle" /> Thank you! Your message has been sent. We'll get back to you soon.
              </div>
            ) : (
              <form className="sa-form" onSubmit={handleSubmit}>
                <div className="sa-form-row">
                  <div className="sa-form-group">
                    <label htmlFor="cu-name">Name *</label>
                    <input id="cu-name" name="name" type="text" value={form.name} onChange={handleChange} placeholder="Your name" required />
                  </div>
                  <div className="sa-form-group">
                    <label htmlFor="cu-email">Email *</label>
                    <input id="cu-email" name="email" type="email" value={form.email} onChange={handleChange} placeholder="Your email" required />
                  </div>
                </div>
                <div className="sa-form-group">
                  <label htmlFor="cu-msg">Message *</label>
                  <textarea id="cu-msg" name="message" rows={7} value={form.message} onChange={handleChange} placeholder="Your message..." required />
                </div>
                <button type="submit" className="sa-btn sa-btn-primary">Send Message</button>
              </form>
            )}
          </div>
        </div>
      </div>

      {/* Google Map */}
      <div className="sa-map-wrapper">
        <iframe
          title="Somayya Academy Location"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d50908.749654937244!2d73.79891784822044!3d18.492016523208015!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xafcd8d4ed94eaf03!2sSomayya%20Engineering%20Academy!5e0!3m2!1sen!2sin!4v1614315337476!5m2!1sen!2sin"
          width="100%"
          height="395"
          style={{ border: 0, display: 'block' }}
          allowFullScreen
          loading="lazy"
        />
      </div>
    </PageLayout>
  );
}
